
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getGameList, getGameRank } from '@/api/gameList'
import { DOWNLOAD_CLIENT_TYPE } from "../constant";
import { DownloadUrls, So360DownloadCallbackData } from "../config/types";
import { downloadResolvedFile } from '../utils/resolveDownloadUrl';

@Component
export default class ListByPc extends Vue {
  @Prop({ required: true }) downloadUrls!: DownloadUrls;
  @Prop({ default: '' }) baiduApiToken!: string;
  @Prop() so360DownloadConfig?: So360DownloadCallbackData;
  public list = []
  public downloadClientType = DOWNLOAD_CLIENT_TYPE;
  public async init() {
    const {data: {data}} = await getGameList()
    const result = (data || []).splice(0, 9)

    const ids = result.map(item => (item as any).gameId);
    const {data: {data: rankData}} = await getGameRank({
      gameIds: ids.join(','),
      gameType: 7
    })
    this.list = result.map(item => {
      const rankItem = rankData.find(row => row.gameId === item.gameId)
      return {
        ...item,
        rankIndex: rankItem.rankIndex,
        gameLabels: (item.gameLabels || []).splice(0, 1)
      }
    })
  }
  public mounted() {
    this.init()
  }

   public handleDownload(type) {
    if (!this.downloadUrls[type][process.env.NODE_ENV]) {
      return;
    }
    const rawUrl = this.downloadUrls[type][process.env.NODE_ENV];
    downloadResolvedFile(rawUrl, type, {
      baiduApiToken: this.baiduApiToken,
      so360DownloadConfig: this.so360DownloadConfig,
      query: this.$route.query,
    });
  }
}
